import { render, staticRenderFns } from "./TheDefault.vue?vue&type=template&id=aa392b80"
import script from "./TheDefault.vue?vue&type=script&lang=ts"
export * from "./TheDefault.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports